"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/*
 * The rules of the "New chat" flow (WhatsApp-style, design D), shared by
 * mobile and web so both read the same:
 *
 *   + → New chat: pick people in To.
 *     · one coworker or team → Message: opens the existing chat with them, or
 *       a new one, from today's default sender (no From).
 *     · one patient → Message → the patient step: Secure text or SMS text, an
 *       optional Name (not for SMS), and From only when two or more texting
 *       teams could send it.
 *     · several → Create group → New group: Name and From, then Create.
 *     · New group (the shortcut) goes to New group even with one person.
 */

var _chat = require('shared/enum/chat');
var _entity = require('shared/services/entity');
var _phone = require('shared/services/phone');
var _chat3 = require('shared/validation/createNew/chat');












 const primaryActionFor = (selected) => {
  if (selected.length > 1) return { label: 'Create group', isEnabled: true, next: 'group' }
  const [only] = selected
  return {
    label: 'Message',
    isEnabled: !!only,
    next: only && _entity.isEntityPatient.call(void 0, only) ? 'patient' : 'chat',
  }
}; exports.primaryActionFor = primaryActionFor

 const chatTypeFor = (hasPatient, channel) => {
  if (!hasPatient) return _chat.CHAT_TYPE.REGULAR
  return channel === 'insecure' ? _chat.CHAT_TYPE.REGULAR_PATIENT : _chat.CHAT_TYPE.SECURE_PATIENT
}; exports.chatTypeFor = chatTypeFor

 const deliveryMethodFor = (chatType) =>
  chatType === _chat.CHAT_TYPE.REGULAR_PATIENT ? _chat.DELIVERY_METHOD.SMS : _chat.DELIVERY_METHOD.SECURE; exports.deliveryMethodFor = deliveryMethodFor

// The patient step shows From only when there's a real choice: two or more
// texting teams in the patient's practice (today's "choose which team").
 const shouldShowPatientFrom = (textingTeamsForPatient) => textingTeamsForPatient >= 2; exports.shouldShowPatientFrom = shouldShowPatientFrom

// An SMS chat can't be named (createSmsConversation takes no name).
 const nameFieldFor = (channel) => (channel === 'insecure'
  ? { isEnabled: false, placeholder: 'Not available for SMS' }
  : { isEnabled: true, placeholder: 'Add a name' }); exports.nameFieldFor = nameFieldFor

// What the create request carries for a typed name. A named chat is always a
// new chat (AlwaysNew); a blank one reuses a chat with the same people.
 const chatNameRequest = (name) => {
  const ChatName = name.trim().slice(0, _chat3.MAX_NAME_LENGTH)
  return ChatName ? { ChatName, AlwaysNew: true } : { ChatName: '' }
}; exports.chatNameRequest = chatNameRequest

// A blank name may open an existing chat; a named one never does.
 const canReuseMatch = (name) => !name.trim(); exports.canReuseMatch = canReuseMatch

 const firstName = (name) => name.split(/\s+/)[0] || name; exports.firstName = firstName

/* A secure text reaches the patient as "<your name> from <practice>", even
 * when a team sends it, so the option says it's from you. */
 const SECURE_OPTION = {
  title: 'Secure text',
  description: (patientName, myName) => {
    const me = _optionalChain([myName, 'optionalAccess', _ => _.trim, 'call', _2 => _2()])
    return `Encrypted, from you${me ? ` (${me})` : ''}. ${exports.firstName.call(void 0, patientName)} reads it in BloomText. OK for PHI.`
  },
}; exports.SECURE_OPTION = SECURE_OPTION

// A team named after its own number ("(619) 332-1021").
const isNamedAfterPhone = (name, phone) =>
  /^[\d\s().+-]+$/.test(name) && _phone.formatPhoneNumber.call(void 0, name) === phone

 const SMS_OPTION = {
  title: 'SMS text',
  description: (senderName, phone) => {
    if (!senderName) return 'Regular text from a team.'
    if (!phone || isNamedAfterPhone(senderName, phone)) return `Regular text from ${phone || senderName}.`
    return `Regular text from ${senderName} · ${phone}.`
  },
}; exports.SMS_OPTION = SMS_OPTION








// Why SMS text can't be picked, or null when it can.
 const insecureBlockedReason = ({ hasPatientMessaging, hasPhoneTeam, recipients }) => {
  if (!hasPatientMessaging) return 'Texting patients isn\'t on your plan'
  if (!hasPhoneTeam) return 'Needs a team with a texting number'
  const patients = recipients.filter(_entity.isEntityPatient).length
  if (patients !== 1 || recipients.length !== 1) return 'One patient only, no coworkers or teams'
  return null
}; exports.insecureBlockedReason = insecureBlockedReason

// The line under a new chat's name: "New secure chat · from you, BloomText".
 const newChatIntro = ({ chatType, senderName, orgName, phone }





) => {
  if (chatType === _chat.CHAT_TYPE.REGULAR_PATIENT) {
    return `New SMS text from ${senderName || 'a team'}${phone ? ` · ${phone}` : ''}`
  }
  const from = senderName ? `from ${senderName}` : `from you${orgName ? `, ${orgName}` : ''}`
  return `New secure ${chatType === _chat.CHAT_TYPE.SECURE_PATIENT ? 'text' : 'chat'} · ${from}`
}; exports.newChatIntro = newChatIntro













/* Which shortcut rows New chat shows, as WhatsApp does. With To empty and
 * nothing typed only New group and Video call lead the list. Once someone is
 * in To they go too (the header's Message / Create group takes over). Add a
 * patient, Add a coworker and Add an external collaborator show only while
 * you type, in a "More" section under the results. */
 const shortcutsFor = ({
  hasQuery, recipientCount, canAddPatients, canAddCoworkers, canAddCollaborators, hasVideo,
}) => {
  const adds = [
    ...(canAddPatients ? ['add-patient' ] : []),
    ...(canAddCoworkers ? ['add-coworker' ] : []),
    ...(canAddCollaborators ? ['add-collaborator' ] : []),
  ]
  const more = hasQuery ? adds : []
  if (hasQuery || recipientCount > 0) return { top: [], more }
  return { top: ['new-group', ...(hasVideo ? ['video-call' ] : [])], more }
}; exports.shortcutsFor = shortcutsFor

/* The second step's cards (design round 8 A). New group: a group name, Send
 * from, and Send as only when a patient is among the members (SMS is then
 * off: one patient only). One patient: a chat name, Send as, and Send from
 * only when there's a real choice of texting team. */
 const cardsFor = ({ step, hasPatient, textingTeams }




) => (step === 'group'
  ? { title: 'New group', action: 'Create', nameLabel: 'Group name', showSendAs: hasPatient, showSendFrom: true }
  : { title: 'New chat', action: 'Open chat', nameLabel: 'Chat name', showSendAs: true, showSendFrom: exports.shouldShowPatientFrom.call(void 0, textingTeams) }); exports.cardsFor = cardsFor

/* Backspace in To, as in WhatsApp: on an empty input it selects (highlights)
 * the last chip; pressed again it removes that chip, and the next press
 * selects the new last one. A selected chip that's gone counts as none.
 * Typing, or tapping anywhere else, deselects (the caller sets null). */
 const chipBackspace = (chipKeys, selected


) => {
  if (selected && chipKeys.includes(selected)) return { selected: null, remove: selected }
  return { selected: _nullishCoalesce(chipKeys[chipKeys.length - 1], () => ( null)), remove: null }
}; exports.chipBackspace = chipBackspace

 const NAME_HELP = 'Optional. Everyone in the chat sees it.'; exports.NAME_HELP = NAME_HELP
 const PHI_WARNING = 'Don\'t include PHI.'; exports.PHI_WARNING = PHI_WARNING

// A chip's label in To. A patient with no name goes by their description
// (birth date or phone), as the Directory titles them.
 const chipLabel = (entity) => entity.name || entity.description || ''; exports.chipLabel = chipLabel

// A member's label under their avatar: a person's first name, a team's name.
 const tileLabel = (entity) => (_entity.isEntityTeam.call(void 0, entity) ? entity.name : exports.firstName.call(void 0, entity.name)); exports.tileLabel = tileLabel
